// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getFavOrigins as listFavOriginsAPI,
    getFavOrigin as getFavOriginAPI,
    addFavOrigin as addFavOriginAPI,
    updateFavOrigin as updateFavOriginAPI,
    deleteFavOrigin as deleteFavOriginAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { favOriginsApiResponseError, favOriginsApiResponseSuccess } from './actions';
import { FavOriginsActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getFavOrigin({ payload: { id } }) {
    try {
        const response = yield call(getFavOriginAPI, id );
        const favOriginItem = response.data.data;
        yield put(favOriginsApiResponseSuccess(FavOriginsActionTypes.GET_FAV_ORIGIN, favOriginItem));
    } catch (error) {
        yield put(favOriginsApiResponseError(FavOriginsActionTypes.GET_FAV_ORIGIN, error));
    }
}

function* addFavOrigin({payload:favOrigin}){
    try{
        const response = yield call(addFavOriginAPI,{...favOrigin})
        const favOriginItem = response.data
        yield put(favOriginsApiResponseSuccess(FavOriginsActionTypes.ADD_FAV_ORIGIN,favOriginItem))
    } catch(error){
        yield put(favOriginsApiResponseError(FavOriginsActionTypes.ADD_FAV_ORIGIN,error))
    }
}

function* updateFavOrigin({payload:favOrigin}){
    try{
        const response = yield call(updateFavOriginAPI,{...favOrigin})
        const favOriginItem = response.data.data
        yield put(favOriginsApiResponseSuccess(FavOriginsActionTypes.UPDATE_FAV_ORIGIN,favOriginItem))
    }catch(error){
        yield put(favOriginsApiResponseError(FavOriginsActionTypes.UPDATE_FAV_ORIGIN,error))
    }
}
function* deleteFavOrigin({payload:{id}}){
    try{
        const response = yield call(deleteFavOriginAPI,id)
        const favOriginItem = response.data.id
        yield put(favOriginsApiResponseSuccess(FavOriginsActionTypes.DELETE_FAV_ORIGIN,favOriginItem))
    }catch(error){
        yield put(favOriginsApiResponseError(FavOriginsActionTypes.DELETE_FAV_ORIGIN,error))
    }
}

/**
 * List contactos
 */
function* listFavOrigins({payload:params}) {
    try {
        const response = yield call(listFavOriginsAPI, { ...params });
        const listaFavOrigins = response.data.data;
        yield put(favOriginsApiResponseSuccess(FavOriginsActionTypes.LIST_FAV_ORIGINS, listaFavOrigins));
    } catch (error) {
        yield put(favOriginsApiResponseError(FavOriginsActionTypes.LIST_FAV_ORIGINS, error));
    }
}


export function* watchGetFavOrigin(): any {
    yield takeEvery(FavOriginsActionTypes.GET_FAV_ORIGIN, getFavOrigin);
}

export function* watchListFavOrigins(): any {
    yield takeEvery(FavOriginsActionTypes.LIST_FAV_ORIGINS, listFavOrigins);
}

export function* watchAddFavOrigin():any{
    yield takeEvery(FavOriginsActionTypes.ADD_FAV_ORIGIN,addFavOrigin)
}
export function* watchUpdateFavOrigin():any{
    yield takeEvery(FavOriginsActionTypes.UPDATE_FAV_ORIGIN,updateFavOrigin)
}
export function* watchDeleteFavOrigin():any{
    yield takeEvery(FavOriginsActionTypes.DELETE_FAV_ORIGIN,deleteFavOrigin)
}


function* favOriginsSaga(): any {
    yield all([
        fork(watchGetFavOrigin),
        fork(watchListFavOrigins),
        fork(watchAddFavOrigin),
        fork(watchUpdateFavOrigin),
        fork(watchDeleteFavOrigin),
    ]);
}

export default favOriginsSaga;
